import {
  SET_CHATLIST,
  SORT_CHATLIST,
  CLEAR_CHATLIST,
  SET_ERROR,
  SET_ERROR_CLEAR,
  SET_SUCCESS_CLEAR,
  SET_NEWSTATUS,
  SENDCHAT_SUCCESS,
  RECEIVE_CHAT,
  MESSAGE_LIST,
  CLEAR_MESSAGE,
  ENDCHAT_SUCCESS,
  ENDASSIGNED_SUCCESS,
  ENDCHAT_AUTO,
  CLEAR_CHATSTATE,
  SET_CHATLIST_READCOUNT,
  ASSIGNED_AGENT,
  UPDATE_CHAT,
  UPDATE_CHAT_SINGLE,
  UPDATE_EMAIL,
  UPDATE_CHAT_CONTACT_INFO,
} from "../Types/ChatTypes";

const chatState = {
  contactSort: { search: "", sort: "date", order: "desc" }, //{search: "", sort:"date/name/agent", order: "asc/desc"}
  contact: [],
  message: [],
  max: 8,
  page: 1,
  chatListViewType: "active", //Chat List viewID on the left side, active/close
  successMessage: "",
  errorMessage: "",
  Mrecords: "",
  Mmax: 8,
  Mpage: 1,
  detailchat: {},
  plChatListID: "", //payload ChatListID
  total: "",
  emitCode: {},
  notReadCountNav: {},
  isEmpty: true,

  // To refetch chat list and message list
  updateChat: true,

  // To update single chat
  updateChatSingle: true,
  chatListIDToUpdate: null,
  isNewChat: false,

  // To refetch email list
  updateEmail: true,

  // To update chat contact info
  updateChatContactInfo: true,
};

const initialState = JSON.parse(JSON.stringify(chatState));

export const chatReducer = (state = chatState, action) => {
  const { payload, type } = action;

  const addAfter = (array, index, newItem) => {
    return [...array.slice(0, index), newItem, ...array.slice(index)];
  };

  const sortContacts = (newSort, newOrder) => {
    let lowerIndex = newOrder === "asc" ? -1 : 1;
    let higherIndex = newOrder === "asc" ? 1 : -1;

    switch (newSort) {
      case "date":
        state.contact.sort(function (x, y) {
          return x.ReceiveTime < y.ReceiveTime
            ? lowerIndex
            : x.ReceiveTime > y.ReceiveTime
            ? higherIndex
            : 0;
        });
        break;
      case "name":
        state.contact.sort(function (x, y) {
          return x.ContactName < y.ContactName
            ? lowerIndex
            : x.ContactName > y.ContactName
            ? higherIndex
            : 0;
        });
        break;
      case "agent":
        state.contact.sort(function (x, y) {
          return x.AgentName < y.AgentName
            ? lowerIndex
            : x.AgentName > y.AgentName
            ? higherIndex
            : 0;
        });
        break;
      default:
        break;
    }
  };

  //IS USED FOR BOTH SEND AND RECEIVE CHAT
  const UpdateChatInfo = (contacts, messages, curChatID, newchat, other) => {
    //CANNOT SET {let state = chatState;} and return the state with updated info
    //other is true if updating other agent end chat
    let plContact,
      plMessage = {};
    //CHECK contacts ?? isArray
    if (Array.isArray(contacts)) {
      if (contacts.length > 0) plContact = contacts[0];
    } else plContact = contacts;
    //CHECK messages ?? isArray
    if (Array.isArray(messages)) {
      if (messages.length > 0) plMessage = messages[0];
    } else plMessage = messages;
    //CHECK CURRENT ACTIVE CHAT VIEW TYPE AND MESSAGE TYPE
    //>>IF CHAT VIEW TYPE !== "active" AND INCOMING MESSAGE THEN STOP
    if (
      plMessage &&
      plMessage.FromMe === false &&
      state.chatListViewType !== "active" &&
      other === undefined
    ) {
      if (plMessage) {
        state.notReadCountNav.TotalUnread++;
      }
      return;
    }

    //SEARCH IF CHAT ID ALREADY EXIST IN CONTACT LIST
    const idx = state.contact.findIndex(
      (x) => x.ChatListID === plContact.ChatListID
    );

    //CHAT ID IS FOUND IN LIST, UPDATE CONTACT
    if (idx > -1) {
      if (plContact.NotReadCount > state.contact[idx].NotReadCount) {
        state.notReadCountNav.TotalUnread++;
      }

      state.contact[idx] = {
        ...state.contact[idx],
        ChatListID: plContact.ChatListID,
        ContactID: plContact.ContactID,
        ContactName: plContact.ContactName,
        LastMessage: plContact.LastMessage,
        NotReadCount: plContact.NotReadCount,
        StatusName: plContact.StatusName.toLowerCase(),
        ReceiveTime: plContact.ReceiveTime,
        ChatSource: "WA",
        Session: plContact.Session,
        MobileNo: plContact.MobileNo,
        AgentID: plContact.AgentID,
        AgentCode: plContact.AgentCode,
        AgentName: plContact.AgentName,
        FromMe: plContact.FromMe,
      };

      sortContacts(state.contactSort.sort, state.contactSort.order);
    } else {
      //CHAT ID IS NOT FOUND, CREATE NEW CONTACT
      if (plMessage && plMessage.FromMe === false) {
        state.notReadCountNav.TotalUnread++;
      }
      let newContact = {
        ChatListID: plContact.ChatListID,
        ContactID: plContact.ContactID,
        ContactName: plContact.ContactName,
        LastMessage: plContact.LastMessage,
        NotReadCount: plContact.NotReadCount,
        StatusName: plContact.StatusName.toLowerCase(),
        ReceiveTime: plContact.ReceiveTime,
        ChatSource: "WA",
        Session: plContact.Session,
        MobileNo: plContact.MobileNo,
        AgentID: plContact.AgentID,
        AgentCode: plContact.AgentCode,
        AgentName: plContact.AgentName,
        IsActive: true,
        FromMe: plContact.FromMe,
      };

      //REMOVE CHAT ID WITH THE SAME CONTACTID
      let existingContactIdx = state.contact.findIndex(
        (x) => x.ContactID === plContact.ContactID
      );
      if (existingContactIdx > -1) {
        state.notReadCountNav.TotalUnread =
          state.notReadCountNav.TotalUnread -
          state.contact[existingContactIdx].NotReadCount;
        state.contact.splice(existingContactIdx, 1); // 2nd parameter means remove one item only
      }
      //Insert on first index, NEED TO CHECK SORTING TYPE
      state.contact.unshift(newContact);
      sortContacts(state.contactSort.sort, state.contactSort.order);
    }

    if (
      !plMessage ||
      (plMessage.FromMe === false && state.chatListViewType !== "active")
    ) {
      return;
    }

    //CHECK ACTIVE CHAT, UPDATE messages IF Active CHATLISTID = message.ChatListID
    //curChatID = 0 >> NEW CHAT, MOVE TO THE NEW CHAT ROOM
    if (plMessage.FromMe && newchat) {
      let plChatListID = curChatID === 0 ? 0 : plContact.ChatListID;
      if (newchat) {
        //replace state.message with messages array
        let records = [...state.message];
        //filter in case of duplicates
        messages.map((element) => {
          if (
            records.findIndex((x) => x.RecordID === element.RecordID) === -1
          ) {
            records = [...records, element];
          }
          return true;
        });
        state = {
          ...state,
          plChatListID: plChatListID,
          message: records,
          Mmax: 1,
          Mpage: 1,
          detailchat: plContact,
        };
      }
    } else {
      //IF RECEIVED CHAT ID = CURRENT OPEN CHAT ID
      if (state.plChatListID === plContact.ChatListID) {
        //unshift doesn't trigger hook??
        //state.message.unshift(plMessage);
        //filter in case of duplicates
        if (
          state.message.findIndex((x) => x.RecordID === plMessage.RecordID) ===
          -1
        ) {
          state.message = addAfter(state.message, 0, plMessage);
        }
      }
    }
    return {
      ...state,
    };
  };

  //"SENDCHAT_SUCCESS" has payload.newchat and "RECEIVE_CHAT" doesn't
  if (type === SENDCHAT_SUCCESS) {
    UpdateChatInfo(
      payload.contact,
      payload.message,
      payload.curChatID,
      payload.newchat
    );

    return {
      ...state,
    };
  }
  if (type === RECEIVE_CHAT) {
    UpdateChatInfo(payload.contact, payload.message, payload.curChatID);

    return {
      ...state,
    };
  }
  if (type === MESSAGE_LIST) {
    let records;
    if (payload.changes || state.message.length === 0) {
      records = [...payload.Mrecords];

      //filter in case of duplicates
      records = records.filter((value, index) => {
        const _value = JSON.stringify(value);
        return (
          index ===
          records.findIndex((records) => {
            return JSON.stringify(records) === _value;
          })
        );
      });
    } else {
      records = [...state.message];
      //filter in case of duplicates
      payload.Mrecords.map((element) => {
        if (records.findIndex((x) => x.RecordID === element.RecordID) === -1) {
          records = [...records, element];
        }
        return true;
      });
    }
    state.detailchat = payload.detailchat;
    return {
      ...state,
      Mmax: payload.Mmax,
      Mpage: payload.Mpage,
      message: records,
      total: payload.total,
      plChatListID: payload.detailchat?.ChatListID,
    };
  }

  if (type === CLEAR_CHATLIST) {
    return {
      ...state,
      contact: [],
      detailchat: {},
      max: 8,
      page: 1,
      chatListViewType: payload.chatListViewType,
    };
  }

  if (type === CLEAR_MESSAGE) {
    return {
      ...state,
      message: [],
      Mmax: 8,
      Mpage: 1,
    };
  }

  if (type === SET_ERROR) {
    return {
      ...state,
      errorMessage: payload.errorMessage,
    };
  }
  if (type === SET_ERROR_CLEAR) {
    return {
      ...state,
      errorMessage: "",
    };
  }
  if (type === SET_SUCCESS_CLEAR) {
    return {
      ...state,
      successMessage: "",
    };
  }

  if (type === SET_CHATLIST) {
    let a = [...state.contact];
    payload.records.forEach((element) => {
      //FIX BUG SWITCH TAB AFTER SCROLL END
      if (state.chatListViewType !== payload.viewType) return;

      const findDuplicate = a.findIndex(
        (x) => x.ChatListID === element.ChatListID
      );
      if (findDuplicate === -1) a = [...a, element];
    });

    state.contact = a;
    sortContacts(state.contactSort.sort, state.contactSort.order);
    return {
      ...state,
      contact: payload.records,
      chatListViewType: payload.viewType,
      detailchat:
        state.chatListViewType === payload.viewType ? state.detailchat : {},
      max: payload.max,
      page: payload.page,
      isEmpty: payload.isEmpty,
    };
  }

  if (type === SET_NEWSTATUS) {
    const findX = state.contact.findIndex(
      (x) => x.ChatListID === payload.chatListID
    );

    if (findX > -1) {
      if (state.contact[findX].NotReadCount > 0)
        state.notReadCountNav.TotalUnread =
          state.notReadCountNav.TotalUnread - state.contact[findX].NotReadCount;

      state.contact[findX].NotReadCount = 0;
      state.contact[findX].StatusName = payload.statusName;
    }

    if (state.detailchat?.ChatListID === payload.chatListID)
      state.message.forEach((msg) => {
        if (msg.StatusID >= payload.statusID) return;

        msg.StatusID = payload.statusID;
        msg.StatusName = payload.statusName;
      });

    if (payload.emit) {
      state.emitCode = {
        code: "readchat",
        ChatListID: payload.chatListID,
      };
    }
    return {
      ...state,
    };
  }

  if (type === ENDCHAT_SUCCESS) {
    //remove chatlist, select none by emptying detailchat
    const endChatIndex = state.contact.findIndex(
      (x) => x.ChatListID === payload.ChatListID
    );
    if (state.chatListViewType === "active" && endChatIndex > -1) {
      state.contact.splice(endChatIndex, 1);
    } else if (state.chatListViewType === "close") {
      UpdateChatInfo(payload.contact, null, null, null, true);
    }
    if (payload.emit) {
      state.emitCode = {
        code: "endchat",
        ChatListID: payload.ChatListID,
        detailchat: payload.detailchat,
        contact: payload.contact,
      };
    }
    if (state.detailchat?.ChatListID === payload.ChatListID)
      state.detailchat = {};

    return {
      ...state,
    };
  }

  if (type === ENDASSIGNED_SUCCESS) {
    //remove chatlist when agent was assigned, select none by emptying detailchat
    const endChatIndex = state.contact.findIndex(
      (x) => x.ChatListID === payload.ChatListID
    );

    const notRead = state.contact[endChatIndex].NotReadCount;

    if (state.chatListViewType === "active" && endChatIndex > -1) {
      state.contact.splice(endChatIndex, 1);
      state.notReadCountNav.TotalUnread =
        state.notReadCountNav.TotalUnread - notRead;
    }
    if (state.detailchat?.ChatListID === payload.ChatListID) {
      state.detailchat = {};
    }

    return {
      ...state,
    };
  }

  if (type === ENDCHAT_AUTO) {
    //remove chatlist, select none by emptying detailchat
    if (state.chatListViewType === "close") {
      UpdateChatInfo(payload.contact, null, payload.curChatID, null);
    } else {
      let endChatIndex = state.contact.findIndex(
        (x) => x.ChatListID === payload.contact.ChatListID
      );
      if (endChatIndex > -1) {
        state.contact.splice(endChatIndex, 1);
      }
      if (state.detailchat?.ChatListID === payload.contact.ChatListID) {
        state.detailchat = {};
        state.message = [];
      }
    }

    return {
      ...state,
    };
  }

  if (type === CLEAR_CHATSTATE) {
    state = initialState;
    return {
      ...state,
    };
  }

  if (type === SORT_CHATLIST) {
    state.contactSort = {
      ...state.contactSort,
      order: payload.order,
      sort: payload.sort,
    };
    sortContacts(state.contactSort.sort, state.contactSort.order);

    return {
      ...state,
    };
  }

  if (type === SET_CHATLIST_READCOUNT) {
    let pl = {};
    if (Array.isArray(payload)) {
      if (payload.length > 0)
        pl = {
          TotalUnread: payload[0].TotalUnread,
          UnassignNotRead: payload[0].UnassignNotRead,
        };
    }
    return {
      ...state,
      notReadCountNav: pl,
    };
  }

  if (type === ASSIGNED_AGENT) {
    return {
      ...state,
      successMessage: "Assigned to: " + payload.detailchat?.AgentName,
    };
  }

  // Refetch chat list and message list on new chat
  if (type === UPDATE_CHAT) {
    return {
      ...state,
      updateChat: !state.updateChat,
    };
  }

  // Update single chat
  if (type === UPDATE_CHAT_SINGLE) {
    return {
      ...state,
      updateChatSingle: !state.updateChatSingle,
      chatListIDToUpdate: payload?.chatListID,
      isNewChat: payload?.isNewChat,
    };
  }

  // Refetch email list
  if (type === UPDATE_EMAIL) {
    return {
      ...state,
      updateEmail: !state.updateEmail,
    };
  }

  // Refetch chat contact info
  if (type === UPDATE_CHAT_CONTACT_INFO) {
    return {
      ...state,
      updateChatContactInfo: !state.updateChatContactInfo,
    };
  }

  return state;
};
